import RadioGroup from '@material-ui/core/RadioGroup';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as FolderWaitBig } from '../../../../images/folder-wait-big.svg';

import { useAppDispatch } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import IndividualCircularLoader from '../../../../components/Loader/IndividualCircularLoader';
import Overlay from '../../../../shared/components/containers/overlay/Overlay';
import { adStudiesActions } from '../../../../store/adStudies/actions';
import { modalsActions } from '../../../modals/modalsSlice';
import useFolders from '../../useFolders';
import ChooseFolderLine from './ChooseFolderLine';
import './chooseFolderModal.scss';

interface IChooseFolderModalProps {
  action: 'MOVE' | 'CREATE';
  currentFolderIdIri: string | null;
}
function ChooseFolderModal({ action, currentFolderIdIri }: IChooseFolderModalProps) {
  const [radioValue, setRadioValue] = useState('');
  const { folders } = useFolders({});
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleCancel = () => {
    // if (action === 'CREATE') {
    dispatch(modalsActions.chooseFolder(null));
    // }
  };

  const handleFolderChooseSubmit = () => {
    if (radioValue !== '') {
      if (action === 'MOVE' && currentFolderIdIri) {
        dispatch(
          adStudiesActions.moveAdStudies.request({
            idIri: radioValue,
            currentFolderIdIri,
          }),
        );
      }
      if (action === 'CREATE') {
        dispatch(
          adStudiesActions.createAdStudies.request({
            idIri: radioValue,
          }),
        );
      }
      dispatch(modalsActions.chooseFolder(null));
    }
  };

  useEffect(() => {
    if (!isEmpty(folders)) {
      const defaultFolder = folders.result?.find((f: any) => f.isDefault === true);
      if (defaultFolder) {
        setRadioValue(defaultFolder.idIri);
      }
    }
  }, [folders]);

  const defaultFolder = folders.result?.find((f: any) => f.isDefault) ?? null;

  return (
    <Overlay>
      <div className="chose-folder">
        <header className="chose-folder-header">
          <div className="chose-folder-title">
            <FolderWaitBig />
            <span>Choisissez votre dossier</span>
          </div>
          <Button
            btnType="button"
            btnContent="+ NOUVEAU"
            primary
            handleClick={() => navigate('/mes-dossiers-creation')}
          />
        </header>

        <div className="chose-folder-content">
          {folders.result === null ? (
            <IndividualCircularLoader size={200} />
          ) : (
            <RadioGroup
              name="chose-folder"
              value={radioValue}
              onChange={(e) => setRadioValue(e.target.value)}
            >
              {folders.result && (
                <>
                  {defaultFolder && (
                    <ChooseFolderLine
                      key={defaultFolder.idIri}
                      folder={defaultFolder}
                    />
                  )}
                  {folders.result
                    ?.filter(
                      (f: any) => f.idIri !== currentFolderIdIri && !f.isDefault,
                    )
                    .map((folder: any) => {
                      return <ChooseFolderLine key={folder.idIri} folder={folder} />;
                    })}
                </>
              )}
            </RadioGroup>
          )}
        </div>

        <footer className="chose-folder-footer">
          <Button
            btnType="button"
            btnContent="ANNULER"
            handleClick={handleCancel}
            textColor="violet"
            bgColor="white"
            borderColor="grey"
          />
          <Button
            btnType="button"
            btnContent="CHOISIR CE DOSSIER"
            primary
            handleClick={handleFolderChooseSubmit}
          />
        </footer>
      </div>
    </Overlay>
  );
}

export default ChooseFolderModal;
